const PREPAY_RETENTION_SHOWN_PROJECTS_KEY = 'wegic_prepay_retention_shown_projects';

function getShownProjectIds(): string[] {
  try {
    const stored = localStorage.getItem(PREPAY_RETENTION_SHOWN_PROJECTS_KEY);
    if (!stored) {
      return [];
    }

    const projectIds: unknown = JSON.parse(stored);
    if (!Array.isArray(projectIds)) {
      return [];
    }

    return projectIds.filter((projectId): projectId is string => typeof projectId === 'string');
  } catch {
    return [];
  }
}

export function hasShownPrepayRetention(projectId: string) {
  if (!projectId) {
    return false;
  }

  return getShownProjectIds().includes(projectId);
}

export function markPrepayRetentionShown(projectId: string) {
  if (!projectId) {
    return;
  }

  const projectIds = getShownProjectIds();
  if (projectIds.includes(projectId)) {
    return;
  }

  try {
    localStorage.setItem(
      PREPAY_RETENTION_SHOWN_PROJECTS_KEY,
      JSON.stringify([...projectIds, projectId]),
    );
  } catch {}
}

export function clearPrepayRetentionShown() {
  try {
    localStorage.removeItem(PREPAY_RETENTION_SHOWN_PROJECTS_KEY);
  } catch {}
}
